<template>
  <div class="debt-overview">
    <LoanSummaryCard :loans="sortedLoans" :total-principal="debt.totalCurrentPrincipal" />
    <MortgageInfoCard :debt="debt" />
    <LoanCard
      v-for="(loan, index) in sortedLoans"
      :key="loan.id"
      :loan="loan"
      :loan-index="index"
      :loan-count="sortedLoans.length"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import type { Debt } from '../debt.types'
import LoanSummaryCard from '../components/LoanSummaryCard.vue'
import MortgageInfoCard from '../components/MortgageInfoCard.vue'
import LoanCard from '../components/LoanCard.vue'

const props = defineProps<{ debt: Debt }>()

const sortedLoans = computed(() => {
  const loans = props.debt.loans
  const bridgeLoans = loans.filter((l) => l.type === 'bridge-loan')
  const mortgageLoans = loans.filter((l) => l.type === 'mortgage')
  return [...bridgeLoans, ...mortgageLoans]
})

// Lands a #lan-<number> link on the right card when the page is opened directly on it.
onMounted(() => {
  const id = window.location.hash.replace(/^#/, '')
  if (id) document.getElementById(id)?.scrollIntoView()
})
</script>

<style scoped lang="scss">
.debt-overview {
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
  margin-top: var(--space-24);
}

// Keeps a card jumped to from the summary clear of the sticky tab bar above it.
.debt-overview {
  --section-card-scroll-margin: 72px;
}
</style>
